import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import { brand } from '../../shared-theme/brand';

export default function Testimonials() {
  return (
    <Box
      id="testimonials"
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: brand.tan,
      }}
    >
      <Container maxWidth="lg">
        <Box component="figure" sx={{ m: 0, maxWidth: 820 }}>
          <Typography
            component="blockquote"
            sx={{
              m: 0,
              fontSize: { xs: '1.4rem', md: '2rem' },
              fontWeight: 500,
              letterSpacing: '-0.02em',
              lineHeight: 1.35,
              color: brand.brown,
              textWrap: 'pretty',
            }}
          >
            “I’ve tested a lot of AI intake tools for law firms. Most are hype.
            OpenIntake actually works.
          </Typography>
          <Typography
            sx={{
              mt: 3,
              fontSize: { xs: '1rem', md: '1.075rem' },
              lineHeight: 1.7,
              color: brand.taupe,
              maxWidth: 680,
            }}
          >
            “We’re using it at Schmidt National Law Group for overflow and
            after-hours calls. It handles real conversations, triages callers,
            and if a case meets prelim criteria, it automatically books a consult
            on our case manager’s calendar and texts the caller confirmation.”
          </Typography>
          <Box
            component="figcaption"
            sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 4 }}
          >
            <Avatar
              src="/scaffa_profile.png"
              alt="Matt Scaffa"
              sx={{ width: 48, height: 48 }}
            />
            <Box>
              <Typography sx={{ fontWeight: 600, color: brand.brown, fontSize: '0.975rem' }}>
                Matt Scaffa
              </Typography>
              <Typography sx={{ color: brand.taupe, fontSize: '0.9rem' }}>
                COO, Schmidt National Law Group
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
